import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { DelegateLoginForm } from '@/features/delegate/components/DelegateLoginForm';
import i18n from '@/shared/i18n';
import { PageTransition } from '@/shared/motion';

export const Route = createFileRoute('/_auth/user/login')({
  // The delegate/resident portal is Arabic. Pin the locale to Arabic BEFORE the
  // page renders so the whole login paints once as RTL/Arabic — no English/Arabic
  // mixing (the shared shell + form both read the same, already-set language).
  beforeLoad: async () => {
    if (!i18n.language.startsWith('ar')) await i18n.changeLanguage('ar');
  },
  component: UserLoginRoute,
});

function UserLoginRoute() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <PageTransition className="flex flex-col gap-6">
      <DelegateLoginForm
        onSuccess={(mustChangePassword) => {
          void navigate({ to: mustChangePassword ? '/user/change-password' : '/user' });
        }}
      />
      <p className="text-center text-xs text-foreground-subtle">
        <Link to="/user/forgot-password" className="font-medium text-foreground-muted underline">
          {t('auth.user.login.forgot')}
        </Link>
      </p>
    </PageTransition>
  );
}
